import script from "./PromoList.vue?vue&type=script&setup=true&lang=js"
export * from "./PromoList.vue?vue&type=script&setup=true&lang=js"

import "./PromoList.vue?vue&type=style&index=0&id=6dbae165&lang=scss"

const __exports__ = script;

export default __exports__